import React from 'react';
import { Mail, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_d2da4572-5a6d-445a-b5f9-58d5fd59f3d9/artifacts/f8wmpwl3_Logo%20Open%20Cortex.svg" 
              alt="Open Cortex" 
              className="footer-logo"
            />
            <p className="footer-tagline">
              Structurer. Automatiser. Décider.
            </p>
            <div className="footer-cta">
              <a href="https://calendly.com/open-cortex/farid-amadet" target="_blank" rel="noopener noreferrer" className="footer-cta-link">
                Prendre RDV
              </a>
            </div>
          </div>
          
          <div className="footer-section">
            <h3>Navigation</h3>
            <ul className="footer-links">
              <li><a href="/">Accueil</a></li>
              <li><a href="/offre">Offre</a></li>
              <li><a href="/methode">Méthode</a></li>
              <li><a href="/pourquoi">Pourquoi Open Cortex</a></li>
              <li><a href="/faq">FAQ</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Contact</h3>
            <div className="footer-contact">
              <a href="mailto:open-cortex@proton.me" className="footer-contact-item">
                <Mail className="footer-icon" />
                <span>open-cortex@proton.me</span>
              </a>
              <a href="tel:+33775713978" className="footer-contact-item">
                <Phone className="footer-icon" />
                <span>+33 7 75 71 39 78</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Open Cortex. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}